export const SET_LOCAL_STORAGE = "SET_LOCAL_STORAGE";
// export const SET_QUOTES_ROOMS = "SET_QUOTES_ROOMS";
// export const SET_QUOTES_TRANSFERS = "SET_QUOTES_TRANSFERS";
// export const SET_QUOTES_ACTIVITIES = "SET_QUOTES_ACTIVITIES";
export const SET_QUOTES_REF = "SET_QUOTES_REF";
export const SET_ADD_ROOMS_HOTEL = "SET_ADD_ROOMS_HOTEL";
export const SET_ADD_ROOMS_APARTMENT = "SET_ADD_ROOMS_APARTMENT";
export const SET_ADD_ROOMS_ACTIVITY = "SET_ADD_ROOMS_ACTIVITY";
export const SET_ADD_ROOMS_TRANSFER = "SET_ADD_ROOMS_TRANSFER";
export const SET_ADD_ET_PAX = "SET_ADD_ET_PAX";
export const SET_ADD_EP_PAX = "SET_ADD_EP_PAX";
export const SET_CLEAR_LOCAL_STORAGE = "SET_CLEAR_LOCAL_STORAGE";

// prompt action types
export const SET_NOTIFICATION_MESSAGE_PROMPT = "SET_NOTIFICATION_MESSAGE_PROMPT";
export const CLEAR_NOTIFICATION_MESSAGE_PROMPT = "CLEAR_NOTIFICATION_MESSAGE_PROMPT";
export const SET_SEARCH_TYPE_LOCAL_STORAGE = "SET_SEARCH_TYPE_LOCAL_STORAGE";